export const handleModalOpen = () => {
  // Prevent scrolling the background when the modal is open
  document.body.style.overflow = 'hidden';
  document.documentElement.style.overflow = 'hidden';
};

export const handleModalClose = () => {
  document.body.style.overflow = 'unset';
  document.documentElement.style.overflow = 'unset';
};
